module.exports = __webpack_public_path__ + "static/media/searchLight.2a149a60.svg";